import { useSelector } from "react-redux";
import { RootState } from "store";


export const useIsGovAccount = (): boolean =>
    useSelector((state: RootState) => state.tenancy.isGovAccount ?? false);